/** Garde les requêtes de chargement Facturation contre les réponses API obsolètes. */
export function createBillingLoadRequestGuard() {
  let requestId = 0;
  let abortController = null;

  return {
    begin() {
      abortController?.abort();
      const controller = new AbortController();
      const currentId = ++requestId;
      abortController = controller;
      return { requestId: currentId, signal: controller.signal };
    },
    invalidate() {
      abortController?.abort();
      requestId += 1;
    },
    isCurrent(requestIdValue) {
      return requestIdValue === requestId;
    },
    dispose() {
      abortController?.abort();
      requestId += 1;
      abortController = null;
    },
  };
}
